// removed by extract-text-webpack-plugin
module.exports = {"theme_switcher":"theme_switcher","theme_switcher_left":"theme_switcher_left","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/ThemeSwitcher/style.scss
// module id = 1365
// module chunks = 0